import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "filename", "info", "actions"]

  connect() {
    this.dragCounter = 0
  }

  // Trigger the hidden file input
  browse() {
    this.inputTarget.click()
  }

  // Handle file selection via input
  picked() {
    const file = this.inputTarget.files[0]
    if (file) this.showFile(file)
  }

  // Drag events
  dragenter(e) {
    e.preventDefault()
    this.dragCounter++
    this.dropzoneTarget.classList.add("drag-over")
  }

  dragleave(e) {
    e.preventDefault()
    this.dragCounter--
    if (this.dragCounter === 0) {
      this.dropzoneTarget.classList.remove("drag-over")
    }
  }

  dragover(e) {
    e.preventDefault()
  }

  drop(e) {
    e.preventDefault()
    this.dragCounter = 0
    this.dropzoneTarget.classList.remove("drag-over")

    const file = e.dataTransfer.files[0]
    if (!file) return

    // Validate extension
    const allowed = [".csv", ".xlsx", ".xls", ".pdf"]
    const ext = file.name.substring(file.name.lastIndexOf(".")).toLowerCase()
    if (!allowed.includes(ext)) {
      this.dropzoneTarget.classList.add("drag-error")
      setTimeout(() => this.dropzoneTarget.classList.remove("drag-error"), 1500)
      return
    }

    // Assign to input
    const dt = new DataTransfer()
    dt.items.add(file)
    this.inputTarget.files = dt.files
    this.showFile(file)
  }

  showFile(file) {
    this.filenameTarget.textContent = file.name
    this.infoTarget.textContent = this.formatSize(file.size)
    this.dropzoneTarget.classList.add("has-file")
    this.actionsTarget.classList.remove("hidden")
  }

  clear(e) {
    e.preventDefault()
    e.stopPropagation()
    this.inputTarget.value = ""
    this.dropzoneTarget.classList.remove("has-file")
    this.actionsTarget.classList.add("hidden")
  }

  formatSize(bytes) {
    if (bytes < 1024) return bytes + " B"
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB"
    return (bytes / 1048576).toFixed(1) + " MB"
  }
}
